import * as t from "io-ts";
export const pushNotificationTokenInputT = t.type({
    fcmToken: t.string,
    deviceId: t.string,
    platform: t.union([
        t.literal("ios"),
        t.literal("android"),
    ]),
});
//# sourceMappingURL=driver-push-notifications-token.js.map